module.exports = __webpack_public_path__ + "img/15vsTakt.6f363a18.png";